module.exports = __webpack_public_path__ + "img/yape.649058db.png";